var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEth = function SvgEth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#186971",
    d: "M4.499 5.547 0 7.64l4.499 2.72 4.497-2.72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2CEDFF",
    d: "m0 7.64 4.499 2.72V0z",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#21B4C1",
    d: "M4.504 0v10.36L9 7.64z",
    opacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2CEDFF",
    d: "M0 8.513 4.5 15v-3.767z",
    opacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#21B4C1",
    d: "M4.504 11.233V15l4.501-6.487z",
    opacity: 0.8
  })));
};
export default SvgEth;